<template>
  <div class="page-wrapper">
      <div class="introduction-container">
        <img :src="require('@/assets/riseuplogo.svg')">
        <div class="greeting">היי,</div>
        <div class="intorduction-text">
          <p>אנחנו שמחים שבחרת להעמיק בתנאי השימוש והפרטיות שלנו.
            זה מסמך משפטי שמתאר את כל המקרים וההתייחסויות שנדרשות בחוק, כדי להגן עליך וגם עלינו.</p>
          <p>השתדלנו שהמסמך יהיה נגיש כמה שאפשר, אם משהו לא ברור או עולות לך שאלות נוספות, נשמח לענות:
            <a class="mail-link" href="mailto:security@riseup.co.il?subject=יש לי שאלה" target="_blank">security@riseup.co.il</a> </p>

        </div>
      </div>
      <legal-card :legals-data="conditions" :name="'תנאי שימוש'"></legal-card>
      <legal-card :legals-data="terms" :name="'מדיניות פרטיות'"></legal-card>
      <div class="last-updated">
        עודכן לאחרונה: 14 במרץ, 2021
      </div>
  </div>
</template>

<script>

import termsJson from './terms.json';
import conditionsJson from './conditions.json';
import LegalCard from './LegalCard.vue';
import Segment from '../../Segment';

export default {
  name: 'TermsAndConditions',
  created() {
    Segment.trackUserGot('TermsAndConditionsEntered');
  },
  components: {
    LegalCard,
  },
  data() {
    return {
      terms: termsJson,
      conditions: conditionsJson,
    };
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../scss/mixins';

  .page-wrapper {
    @include page-frame;
    font-family: SimplerPro;

    .introduction-container {
      color: $riseup_black;
      padding-bottom: 16px;

      img {
        display: block;
        margin: auto;
      }

      .greeting {
        font-size: 24px;
        line-height: 1;
        font-family: GretaSans
      }

      .intorduction-text {
        font-size: 16px;
        line-height: 1.5;

        a {
          font-family: SimplerProBold;
          color: $riseup_blue;
        }
      }
    }

    .last-updated {
      color: $riseup_gray_2;
      font-family: SimplerPro;
    }
  }
</style>
